import {
  Box,
  Button,
  Flex,
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
  Text,
  VStack,
} from "@chakra-ui/react";
import { RiAddFill, RiFileExcel2Line, RiSearch2Fill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";
import {
  openAddSubjectAdmin,
  openCreateStudent,
} from "../../../modules/admin-modules/models/Actions";
import { addBulkStudentRequest } from "../../../modules/admin-modules/students/Actions";
import ExportUsersButton from "./exportcsv";

const SearchBar = ({ setAdd, setSearchTerm }) => {
  const user = useSelector((state) => state.user.userData);
  const dispatch = useDispatch();
  const isSuperAdmin =
    Array.isArray(user?.role) &&
    user.role.some((r) => r?.name === "Super Admin");

  return (
    <VStack w="100%" my={{ base: "50px", md: "30px" }}>
      <Flex
        alignItems="center"
        w="100%"
        justifyContent="space-between"
        flexWrap="wrap"
      >
        <Text
          fontSize="24px"
          fontWeight="600"
          color="main_1"
          width={{ base: "100%", md: "20%" }}
          mb={{ base: "10px", md: 0 }}
        >
          الطلاب
        </Text>

        <Flex alignItems="center" flexWrap="wrap" gap={2}>
          <Button
            borderRadius="16px"
            leftIcon={<RiAddFill />}
            color="white"
            bg="main_1"
            _focus={{ outline: "none" }}
            onClick={() => {
              setAdd(true);
              dispatch(openCreateStudent());
            }}
          >
            إضافة طالب
          </Button>

          {isSuperAdmin && (
            <Button
              borderRadius="16px"
              leftIcon={<RiAddFill />}
              color="white"
              bg="main_1"
              _focus={{ outline: "none" }}
              onClick={() => {
                setAdd(true);
                dispatch(openAddSubjectAdmin());
              }}
            >
              إضافة مادة
            </Button>
          )}
          <ExportUsersButton />
          <Button
            borderColor="main_1"
            border="1px solid"
            mx="10px"
            borderRadius="16px"
            leftIcon={<RiFileExcel2Line />}
            color="main_1"
            bg="white"
            _focus={{ outline: "none" }}
            position="relative"
          >
            <Text>Add Students in Bulk</Text>
            <Input
              onChange={(e) => {
                let formData = new FormData();
                formData.append("student_bulk", e.target.files[0]);
                dispatch(addBulkStudentRequest(formData));
              }}
              type="file"
              placeholder="اختر ملف ليتم رفعه"
              opacity="0"
              position="absolute"
              w="100%"
              h="100%"
            />
          </Button>

          <Box display={{ base: "none", md: "block" }}>
            <LogoutMenu />
          </Box>
        </Flex>
      </Flex>

      {/* <Text w="100%" fontSize="20px" textAlign="right">
        عدد الطلاب :{count}{" "}
      </Text> */}

      <HStack
        w="100%"
        justifyContent="space-between"
        bg="#f5f5f5"
        mt="40px !important"
        p="10px"
        mb="-30px !important"
      >
        <InputGroup w="400px">
          <InputLeftElement
            pointerEvents="none"
            children={<RiSearch2Fill color="main_1" fontSize="20px" />}
          />
          <Input
            type="text"
            placeholder="ابحث باسم الطالب أو رقم الموبايل"
            borderRadius="16px"
            bg="white"
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </InputGroup>
      </HStack>
    </VStack>
  );
};

export default SearchBar;
